import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cardFlightInfoBox: {
    width: '100%',
    flexGrow: '1',

    '&:nth-of-type(1)': {
      paddingBottom: 24,
    },
    '&:nth-of-type(2)': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 24,

      [Theme.breakpoints.up('xl')]: {
        paddingLeft: '24px',
        borderLeft: `1px solid ${Theme.palette.gray[250]}`,
        paddingTop: '0',
        borderTop: 'none',
      },
    },

    '&.summary:nth-of-type(2)': {
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingTop: 24,
      borderLeft: 0,
      paddingLeft: 0,
    },
  },
  justifiedFlightInfo: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',

    [Theme.breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
    },

    '& span': {
      display: 'flex',
      color: Theme.palette.gray[500],
    },
  },

  isBrowsePath: {
    flexWrap: 'wrap',
  },
  flightDateWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [Theme.breakpoints.up('md')]: {
      alignItems: 'center',
      flexDirection: 'row',
    },

    '& .details-actions': {
      display: 'flex',
      width: '100%',
      gap: 20,
      flex: 'auto',
      justifyContent: 'flex-end',

      [Theme.breakpoints.up('sm')]: {
        width: 'unset',
      },
    },
  },
  flightAirlineLogo: {
    height: '26px',
    width: '26px',
    position: 'relative',
    [Theme.breakpoints.down('md')]: {
      top: '0',
    },
    [Theme.breakpoints.down('sm')]: {
      height: '21px',
      width: '21px',
    },
  },
  flightDate: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    marginLeft: '10px',
    [Theme.breakpoints.up('sm')]: {
      textWrap: 'nowrap',
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[3],
    },
  },
  flightDatePanel: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[3],
    color: Theme.palette.primary.main,
    marginLeft: '10px',
  },
  flightInfo: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '20px',
    gap: '10px',
    justifyContent: 'space-between',
  },

  flightInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  firstColumn: {
    minWidth: '210px',
    [Theme.breakpoints.up('md')]: {
      minWidth: '360px',
    },
  },
  firstColumnPanel: {
    marginRight: '83px',
    [Theme.breakpoints.down('lg')]: {
      marginRight: '-6px',
    },
  },
  secondColumn: {
    [Theme.breakpoints.up('lg')]: {
      width: '100px',
      marginRight: '54px',
    },
  },
  thirdColumn: {
    [Theme.breakpoints.up('lg')]: {
      width: '90px',
      marginRight: '54px',
    },
  },
  fourthColumn: {
    '& div': {
      textAlign: 'right',
    },
    [Theme.breakpoints.up('lg')]: {
      width: '100px',
    },
  },
  flightInfoDownLgHide: {
    [Theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  flightInfoDownLgHidePanel: {
    display: 'none',
  },
  flightInfoDownLgShow: {
    display: 'none',
    [Theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  flightInfoDownLgShowPanel: {
    display: 'block',
  },
  flightInfoPrimary: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.semiBold,
  },
  flightInfoSecondary: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[500],
    textWrap: 'nowrap',
    marginTop: '5px',
    '& p': {
      margin: '0',
      lineHeight: '150%',
    },
    [Theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    [Theme.breakpoints.down('lg')]: {
      maxWidth: '430px',
    },
    [Theme.breakpoints.down('sm')]: {
      textWrap: 'wrap',
    },
  },
  flightInfoSecondaryExtraInfo: {
    display: 'none',
    marginTop: '5px',
    '& p': {
      margin: '0',
      lineHeight: '150%',
    },
    [Theme.breakpoints.down('lg')]: {
      display: 'flex',
      maxWidth: '380px',
    },
    [Theme.breakpoints.down('md')]: {
      maxWidth: '430px',
    },
  },
  flightInfoSecondaryExtraInfoDownSmHide: {
    [Theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  flightInfoSecondaryExtraInfoDownSmHidePanel: {
    display: 'none',
  },
  flightInfoSecondaryExtraInfoDownSmShow: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  flightInfoSecondaryExtraInfoDownSmShowPanel: {
    display: 'block',
  },
  flightInfoOperatedBy: {
    marginTop: '5px',
  },

  layoverDaysReview: {
    fontSize: 'smaller',
    position: 'relative',
    top: '-5px',
  },
  flightDetails: {
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: 0,
    textWrap: 'nowrap',
    alignSelf: 'normal',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    color: Theme.palette.primary.light,
    textAlign: 'right',
  },
  flightDetailsPanel: {
    display: 'none',
  },
  flightDetailsSM: {
    display: 'none',
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    marginTop: '10px',
    color: Theme.palette.primary.light,
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  flightDetailsSMPanel: {
    display: 'block',
    fontSize: Theme.typography.size[1],
    lineHeight: '150%',
    marginTop: '10px',
    color: Theme.palette.primary.light,
  },
  iconAirlineAndDate: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    [Theme.breakpoints.up('xl')]: {
      width: '378px',
    },
  },
  withReservationNumber: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  confirmationNumber: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    lineHeight: '150%',
    marginTop: '10px',
    textWrap: 'pretty',
    '& .singleLine': {
      textWrap: 'nowrap',
    },
    [Theme.breakpoints.up('md')]: {
      margin: '0px 25px',
    },
    [Theme.breakpoints.only('lg')]: {
      maxWidth: '205px',
      margin: '0px 15px 0px 25px',
    },
  },
  aaLoyaltyMessage: {
    lineHeight: '20px',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.primary.main,
    margin: '10px 0 0 0',
    fontWeight: 600,
    fontFamily: Theme.typography.base.regular,
  },
}));

export default useStyles;
